import SectionLabel from "@/components/base/SectionLabel";
import { aiOfficeData } from "@/mocks/aiOfficeData";

export default function DeliverablesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={aiOfficeData.deliverables.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {aiOfficeData.deliverables.title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="reveal relative rounded-lg overflow-hidden bg-background-100 border border-background-200/70 p-6 md:p-8">
            {/* Top: document stack mockup */}
            <div className="flex items-center justify-center gap-4 mb-8">
              <div className="w-16 h-20 md:w-20 md:h-24 rounded-md bg-background-50 border border-background-200 shadow-sm rotate-[-4deg] flex items-center justify-center">
                <i className="ri-file-text-line text-primary-400 text-2xl" />
              </div>
              <div className="w-16 h-20 md:w-20 md:h-24 rounded-md bg-background-50 border border-background-200 shadow-sm rotate-[2deg] flex items-center justify-center -ml-4">
                <i className="ri-calendar-todo-line text-primary-400 text-2xl" />
              </div>
              <div className="w-16 h-20 md:w-20 md:h-24 rounded-md bg-background-50 border border-background-200 shadow-sm flex items-center justify-center -ml-4">
                <i className="ri-book-open-line text-primary-500 text-2xl" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 md:gap-x-6 gap-y-2.5 md:gap-y-3">
              {aiOfficeData.deliverables.items.map((item, idx) => (
                <div
                  key={idx}
                  className="reveal flex items-center gap-2.5 md:gap-3"
                  style={{ transitionDelay: `${idx * 60}ms` }}
                >
                  <div className="w-6 h-6 md:w-7 md:h-7 rounded-md bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary-500 text-xs md:text-sm`} />
                  </div>
                  <span className="text-sm md:text-base text-foreground-700">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}